module.exports = __webpack_public_path__ + "static/img/v1.a2b97867.png";